<div style="overflow-y: auto; height: calc(100vh - 8.563rem);">
    <div style="text-align: center">
        <span *ngIf="data.isFormOwner" style="font-size: 1.688rem; color: #4c4c4c">Manage Form Owner</span>
        <span *ngIf="!data.isFormOwner" style="font-size: 1.688rem; color: #4c4c4c">Manage Assignment</span>
    </div>
    <div>
        <span *ngIf="data.isFormOwner" class="projectScopeHeader">Form Owner</span>
        <span *ngIf="!data.isFormOwner" class="projectScopeHeader">Assigned To</span>
    </div>
    <div *ngIf="data.isFormOwner" style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(formOwner && formOwner.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="formOwnerField"
              type="text"
              placeholder="Form Owner (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="formOwnerControl"
              [(ngModel)]="formOwner"
              required
              (keydown.enter)="searchUsersFormOwner($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="formOwner && formOwner.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="formOwnerField"
              type="text"
              placeholder="Form Owner (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto1"
              [formControl]="formOwnerControl"
              [(ngModel)]="formOwner"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="displayFnFormOwner"
          >
            <mat-option
              *ngFor="let option of formOwnerOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="formOwner && formOwner.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deleteFormOwner()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersFormOwner(formOwner)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
    <div *ngIf="!data.isFormOwner" style="margin-top: 0.688rem;">
        <div
          style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd; position: relative;"
        >
          <mat-form-field
            *ngIf="!(currentAssignment && currentAssignment.mail)"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="currentAssignmentField"
              type="text"
              placeholder="Assigned To (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto3"
              [formControl]="currentAssignmentControl"
              [(ngModel)]="currentAssignment"
              required
              (keydown.enter)="searchUsersCurrentAssignment($event.target.value)"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="currentAssignment && currentAssignment.mail"
            class="itFields"
            style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem;"
          >
            <input
              name="currentAssignmentField"
              type="text"
              placeholder="Current Assignment (Search for a name and then make a selection)"
              matAutocompletePosition="below"
              matInput
              [matAutocomplete]="auto3"
              [formControl]="currentAssignmentControl"
              [(ngModel)]="currentAssignment"
              readonly="true"
            />
          </mat-form-field>
          <mat-autocomplete
            #auto3="matAutocomplete"
            [displayWith]="displayFnCurrentAssignment"
          >
            <mat-option
              *ngFor="let option of currentAssignmentOptions"
              style="color: #696969"
              [value]="option"
            >
              <span
                *ngIf="option.givenName && option.surname && option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="option.givenName && option.surname && !option.jobTitle"
                >{{option.givenName}} {{option.surname}} ({{option.mail}})</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && option.jobTitle"
                >{{option.displayName}} ({{option.mail}}),
                {{option.jobTitle}}</span
              >
              <span
                *ngIf="!(option.givenName && option.surname) && !option.jobTitle"
                >{{option.displayName}} ({{option.mail}})</span
              >
            </mat-option>
          </mat-autocomplete>
          <div
            *ngIf="currentAssignment && currentAssignment.mail"
            style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute;"
          >
            <img
              (click)="deleteCurrentAssignment()"
              style="margin-left: -1.5rem; cursor: pointer"
              src="assets/close-window.svg"
            />
          </div>
          <div style="display: inline-block; margin-left: 0.938rem;">
            <button
              class="confirmButton"
              type="button"
              style="width: 5rem"
              (click)="searchUsersCurrentAssignment(currentAssignment)"
            >
              <span class="confirmText">SEARCH</span>
            </button>
          </div>
        </div>
      </div>
      <div style="text-align: center">
        <div style="display: inline-block; margin-top: 2.625rem; margin-right: 0.875rem;">
          <div class="exitButton" (click)="closeDialog()">
            <span class="exitText">CANCEL</span>
          </div>
        </div>
        <div style="display: inline-block; margin-top: 2.625rem;">
          <button class="confirmButton" (click)="saveAndClose()">
            <span class="confirmText">SAVE CHANGES</span>
          </button>
        </div>
      </div>
    <div>
</div>